import { Button, Col, Dropdown, Form, Input, Row, Spin, Switch } from 'antd';
import React, { useState, useContext, useEffect } from 'react';
import styles from './styles.module.scss';
import {
  SelectNumberInput,
  SelectStringInput,
} from '../../../../../select-input';
import {
  IsAdminContext,
  NumberOfSoftSkillontext,
  SkillListContext,
  UserSkillDataContext,
} from '../../../../../../../context';
import axiosInstance from '../../../../../../../axios_instance';
import { useParams } from 'react-router-dom';
import { errorHandling } from '../../../../../../../utils/helper';
import styled from 'styled-components';
import errorColumnMap from '../../../../../../../utils/error-message-mapping';
import { IsNumberValidator } from '../../../../../../../utils/validators';

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;

const AddSkill: React.FC<{ setAddNew: any }> = ({
  setAddNew,
}: {
  setAddNew: any;
}) => {
  const skillListFromContext = useContext(SkillListContext);
  const [skillValue, setSkillValue] = useState<number>();
  const [levelValue, setLevelValue] = useState<number>();
  const [hasCertificate, setHasCertificate] = useState<number | string>();
  // const [hasAchievement, setHasAchievement] = useState<number | string>();
  const [formData, setFormData] = useState<{ [key: string]: number }>({});
  const { userSkillData, setUserSkillData } = useContext(UserSkillDataContext);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const [message, setMessage] = useState<string>();
  const { numberOfSoftSkills, setNumberOfSoftSkills } = useContext(NumberOfSoftSkillontext);

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const handleChangeResume = (value: any) => {
    setFormData({
      ...formData,
      ["show_in_resume"]: value,
    });
  };

  const handleSave = () => {
    setIsSubmitted(true)
    const requestBody: { [key: string]: any } = {};
    requestBody['skill_id'] = skillValue;
    requestBody['certificate'] = hasCertificate;
    requestBody['level'] = levelValue;
    requestBody['experience_year'] = formData['experience_year'];
    requestBody['show_in_resume'] = 'show_in_resume' in formData ? formData['show_in_resume'] : true;
    requestBody['status'] = '1';
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/skills';
      requestBody['profile_id'] = employeeId;
    } else {
      url = '/api/v1/profile/skills';
    }
    axiosInstance
      .post(url, requestBody)
      .then((response) => {
        const userSkills = response.data.skills.filter(
          (skill: any) =>
            skill['status']['id'] === 1 && skill['skill_type']['id'] === 2
        );
        const orderedSkills = response.data.order_soft_skills.map((skillId: number) =>
          userSkills.find((userSkill: any) => userSkill.skill_id === skillId)
        ).filter((item: any) => item !== undefined);
        setUserSkillData(orderedSkills);
        setNumberOfSoftSkills(userSkills.length);
        setAddNew(false);
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false)
      });

  };
  useEffect(() => {
    if (userSkillData.find((data: any) => data.skill_id === skillValue)) {
      setMessage("The skill already exists.")
    }
    else {
      setMessage("");
    }
  }, [skillValue])


  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row className={styles.row}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked onChange={handleChangeResume} /><span>Show in resume</span></div>

          <Col span={12}>
            {message ? <Row><p style={{ color: "green" }}>{message}</p></Row> : <></>}
            <p>
              <span className={styles.title}>Skill : </span>
              <StyledSelectStringInput
                {...{
                  optionList: skillListFromContext,
                  width: 200,
                  placeHolder: 'Select Skills',
                  setValue: setSkillValue,
                }}
              />
            </p>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Level : </span>
                  <StyledSelectStringInput
                    {...{
                      optionList: {
                        '01': 1,
                        '02': 2,
                        '03': 3,
                        '04': 4,
                        '05': 5,
                        '06': 6,
                        '07': 7,
                        '08': 8,
                        '09': 9,
                        '10': 10,
                      },
                      width: 100,
                      placeHolder: 'Select Level',
                      setValue: setLevelValue,
                    }}
                  />
                </p>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="experience_year"
                  label=""
                  rules={[IsNumberValidator]}
                >
                  <p>
                    <span className={styles.title}>Experiences (Years) : </span>
                    <Input
                      className={styles.input}
                      onChange={handleChange}
                      name="experience_year"
                      required
                      style={{
                        borderBottom:
                          'experience_year' in errorMessage
                            ? '1px solid red'
                            : '',
                      }}
                    />
                  </p>
                </Form.Item>
                <Row>
                  <p style={{ color: 'red' }}>
                    {'experience_year' in errorMessage
                      ? errorMessage['experience_year']
                      : ''}
                  </p>
                </Row>
              </Col>
            </Row>
            <p>
              <span className={styles.title}>Certificates : </span>
              <StyledSelectStringInput
                {...{
                  optionList: { Yes: 1, No: 0 },
                  width: 100,
                  placeHolder: 'Do you have any certificate for this skill?',
                  setValue: setHasCertificate,
                }}
              />
            </p>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              type="primary"
              htmlType="submit"
              disabled={
                !skillValue || !levelValue || !formData['experience_year']
              }
            >
              Save
            </Button>
          </Form.Item>
          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setAddNew(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default AddSkill;
